import {useMutation, useQueryClient} from "@tanstack/react-query";
import {TRANSACTIONS_QUERY_KEY} from "@/pages/private/Transactions/useTransactions";
import {WALLET_QUERY_KEY} from "@/pages/private/Wallet/useWallet";
import type {DepositPagoMovilPayload} from "./depositPagoMovil.schema";
import {type DepositPagoMovilResponse, depositPagoMovilService} from "./depositPagoMovil.service";

export interface UseDepositPagoMovilResult {
  submit: (payload: DepositPagoMovilPayload) => void;
  isPending: boolean;
  isSuccess: boolean;
  isError: boolean;
  error: Error | null;
  data: DepositPagoMovilResponse | undefined;
  reset: () => void;
}

export const useDepositPagoMovil = (): UseDepositPagoMovilResult => {
  const queryClient = useQueryClient();
  const mutation = useMutation<DepositPagoMovilResponse, Error, DepositPagoMovilPayload>({
    mutationFn: depositPagoMovilService,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: WALLET_QUERY_KEY});
      queryClient.invalidateQueries({queryKey: [TRANSACTIONS_QUERY_KEY]});
    },
  });

  return {
    submit: mutation.mutate,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    reset: mutation.reset,
  };
};
